// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 0px) {
  .feature-row-container {
    padding: 0 0 0 0;
  }
}
@media screen and (min-width: 667px) {
  .feature-row-container {
    padding: 0 0 0 0;
  }
}
@media screen and (min-width: 900px) {
  .feature-row-container {
    padding: 0 0 0 0;
  }
}
@media screen and (min-width: 1200px) {
  .feature-row-container {
    padding: 0 0 0 0;
  }
}

.feature-image {
  object-fit: contain;
  width: 100%;
  filter: drop-shadow(1px 1px 5px rgba(255, 255, 255, 0.25));
}
@media screen and (min-width: 0px) {
  .feature-image {
    max-width: 220px;
  }
}
@media screen and (min-width: 900px) {
  .feature-image {
    max-width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .feature-image {
    max-width: 100%;
    padding: 0 0 0 0;
  }
}

.feature-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 700;
  /* or 116% */
  text-align: left;
  letter-spacing: 0.374px;
  color: #FFFFFF;
}
@media screen and (min-width: 0px) {
  .feature-title {
    font-size: 28px;
    line-height: 33px;
    max-width: 260px;
  }
}
@media screen and (min-width: 667px) {
  .feature-title {
    font-size: 34px;
    line-height: 41px;
    max-width: 461px;
  }
}
@media screen and (min-width: 900px) {
  .feature-title {
    padding: 100px 0 0 0;
    font-size: 38px;
    line-height: 44px;
    max-width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .feature-title {
    padding-top: 100px;
    font-size: 38px;
    line-height: 44px;
    max-width: 100%;
  }
}

.feature-subtitle {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-align: left;
  letter-spacing: 0.38px;
  color: #8E8E93;
}
@media screen and (min-width: 0px) {
  .feature-subtitle {
    font-size: 17px;
    line-height: 22px;
    padding-top: 20px;
    padding-bottom: 50px;
    max-width: 260px;
  }
}
@media screen and (min-width: 667px) {
  .feature-subtitle {
    font-size: 17px;
    line-height: 22px;
    padding-top: 30px;
    max-width: 461px;
  }
}
@media screen and (min-width: 900px) {
  .feature-subtitle {
    font-size: 20px;
    line-height: 24px;
    padding-top: 30px;
    max-width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .feature-subtitle {
    font-size: 20px;
    line-height: 24px;
    padding-top: 30px;
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/feature-row.scss"],"names":[],"mappings":"AAOE;EAFF;IAGI,gBAAA;EALF;AACF;AAOE;EANF;IAOI,gBAAA;EAJF;AACF;AAME;EAVF;IAWI,gBAAA;EAHF;AACF;AAKE;EAdF;IAeI,gBAAA;EAFF;AACF;;AAKA;EACE,mBAAA;EACA,WAAA;EACA,0DAAA;AAFF;AAKE;EANF;IAOI,gBAAA;EAFF;AACF;AAQE;EAdF;IAeI,eAAA;EALF;AACF;AAOE;EAlBF;IAmBI,eAAA;IACA,gBAAA;EAJF;AACF;;AAOA;EACE,kJAAA;EACA,kBAAA;EACA,gBAAA;EAEA,YAAA;EACA,gBAAA;EACA,uBAAA;EAEA,cAAA;AANF;AAQE;EAXF;IAYI,eAAA;IACA,iBAAA;IACA,gBAAA;EALF;AACF;AAOE;EAjBF;IAkBI,eAAA;IACA,iBAAA;IACA,gBAAA;EAJF;AACF;AAME;EAvBF;IAwBI,oBAAA;IACA,eAAA;IACA,iBAAA;IACA,eAAA;EAHF;AACF;AAKE;EA9BF;IA+BI,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,eAAA;EAFF;AACF;;AAKA;EACE,kJAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EAGA,cAAA;AAJF;AAME;EAZF;IAaI,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,oBAAA;IACA,gBAAA;EAHF;AACF;AAKE;EApBF;IAqBI,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,gBAAA;EAFF;AACF;AAIE;EA3BF;IA4BI,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,eAAA;EADF;AACF;AAGE;EAlCF;IAmCI,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,eAAA;EAAF;AACF","sourcesContent":["$extra-small: 0px;\n$small: 667px;\n$medium: 900px;\n$large: 1200px;\n\n.feature-row-container {\n\n  @media screen and (min-width: $extra-small) {\n    padding: 0 0 0 0;\n  }\n\n  @media screen and (min-width: $small) {\n    padding: 0 0 0 0;\n  }\n\n  @media screen and (min-width: $medium) {\n    padding: 0 0 0 0;\n  }\n\n  @media screen and (min-width: $large) {\n    padding: 0 0 0 0;\n  }\n}\n\n.feature-image {\n  object-fit: contain;\n  width: 100%;\n  filter: drop-shadow(1px 1px 5px rgba(255, 255, 255, 0.25));\n\n\n  @media screen and (min-width: $extra-small) {\n    max-width: 220px;\n  }\n\n  @media screen and (min-width: $small) {\n    //max-width: 280px;\n  }\n\n  @media screen and (min-width: $medium) {\n    max-width: 100%;\n  }\n\n  @media screen and (min-width: $large) {\n    max-width: 100%;\n    padding: 0 0 0 0;\n  }\n}\n\n.feature-title {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: 700;\n\n  /* or 116% */\n  text-align: left;\n  letter-spacing: 0.374px;\n\n  color: #FFFFFF;\n\n  @media screen and (min-width: $extra-small) {\n    font-size: 28px;\n    line-height: 33px;\n    max-width: 260px;\n  }\n\n  @media screen and (min-width: $small) {\n    font-size: 34px;\n    line-height: 41px;\n    max-width: 461px;\n  }\n\n  @media screen and (min-width: $medium) {\n    padding: 100px 0 0 0;\n    font-size: 38px;\n    line-height: 44px;\n    max-width: 100%;\n  }\n\n  @media screen and (min-width: $large) {\n    padding-top: 100px;\n    font-size: 38px;\n    line-height: 44px;\n    max-width: 100%;\n  }\n}\n\n.feature-subtitle {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  text-align: left;\n  letter-spacing: 0.38px;\n\n\n  color: #8E8E93;\n\n  @media screen and (min-width: $extra-small) {\n    font-size: 17px;\n    line-height: 22px;\n    padding-top: 20px;\n    padding-bottom: 50px;\n    max-width: 260px;\n  }\n\n  @media screen and (min-width: $small) {\n    font-size: 17px;\n    line-height: 22px;\n    padding-top: 30px;\n    max-width: 461px;\n  }\n\n  @media screen and (min-width: $medium) {\n    font-size: 20px;\n    line-height: 24px;\n    padding-top: 30px;\n    max-width: 100%;\n  }\n\n  @media screen and (min-width: $large) {\n    font-size: 20px;\n    line-height: 24px;\n    padding-top: 30px;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
